<script>
	import Alert from './components/Alert.svelte';
	import ButtonViewsXpages from './componentes/ButtonViewsXpages.svelte';
	import Helper from './components/Helper.svelte';
    import BotonOrder from './componentes/BotonOrder.svelte'; // CAMBIO AGREGAR 
    import { viewsXpages, registerXpage, urlapp, sucursal } from './stores/store.js'; // CAMBIO AGREGAR quitar duplicado  
	  import Modal from './components/Modal.svelte';
    import Input from './componentes/Forms/Input.svelte';
    import { fade, fly } from 'svelte/transition';
    import { push } from 'svelte-spa-router';
    import AnimationContainer from './components/AnimationContainer.svelte';
    import Navbar from './components/Navbar.svelte';
    import Titlesection from "./components/Titlesection.svelte";
    import { autentificado, prefix, urlapi, login,miPermiso,iduser } from './stores/store';

    import DatagridRow from './componentes/DatagridRow.svelte';
    import DatagridTitle from './componentes/DatagridTitle.svelte';
    import DatagridCell from './componentes/DatagridCell.svelte';
    import Datagrid from './componentes/Datagrid.svelte';

    import Infopagination from './components/Infopagination.svelte';
    import Pagination from './components/Pagination.svelte';
    import Searchsection from "./components/Searchsection.svelte";
    import { moneda, object2array, postData, verifyAccess } from './scripts';

    import moment from 'moment';

    verifyAccess($login,$miPermiso,'productos','access')

    /* PERMISOS */
    let viewPage=false;

    if($login===false)
    {
        push('/login')
    } else if( $miPermiso.productos.access===false ) {
        push('/sinpermiso')
    } else {
        viewPage=true;
    }
    /* FIN PERMISOS */

    let avanzado=false;
    const res=null;
    let datagrid=[]
    let cargando=false;
    let pageActual=0;
    let dataPagination={};
    let searchText='';
    let orderField='codigo';
    let orderDir='ASC';
    let uid=null; // CAMBIO AGREGAR VARIABLE

    let offcanvas_cortediaUNI=false;
    let Bsoffcanvas_cortediaUNI=false;
    let fecha_cortediaUNIdesde='';
    let fecha_cortediaUNIhasta='';
    let observaciones_cortediaUNI='';
    let campo_cortediaUNI=null;

    let error_eliminar_existencia=false;

    function eventPage(event)
    {
        pageActual=event.detail.text;
        loadData()
    }

    function eventSearch(event)
    {
        pageActual=0;
        searchText=event.detail.text
        loadData()
    }

    function eventText()
    {
        pageActual=0;
        loadData()
    }

    async function loadData()
    {
        cargando=true;
        let datos={ 
            'cmd': "productos_list",
            sucursal: $sucursal,
            pagination: $viewsXpages,
            page: pageActual,
            order: orderField,
            dir: orderDir,
        }
        // CAMBIO AGREGAR CONDICION Y BORRAR SEARCH DE ARRIBA
        if(avanzado===true)
        {
            if(searchText!='') datos={...datos, 'search':searchText }
        }

        const res = await postData($urlapi, [datos])
        .then(data => {
            datagrid= object2array(data[0].result);
            dataPagination=data[0].pagination;
            cargando=false;
        });
        
    }

    let edit= function(id) { push('/productos/'+id); }
    let kardex=function(id) { 
        let obj = datagrid.find(o => o.id === id);
        if(obj!==undefined) push('/kardex/'+obj.codigo)
    }
    let nuevo=function () { push('/productos/new')}

    let eliminar=function() {
        error_eliminar_existencia=false

        postData($urlapi, [{ 'cmd':'productos_existencia', 'id':seleccionado }])
        .then(data => {
                if( parseInt( data[0].result.existencia )==0 )
                {
                    postData($urlapi, [{ 
                        'cmd':'productos_eliminar', 
                        'id':seleccionado,
                    }]).then(data => {
                        pageActual=0;
                        loadData()
                    });
                } else {
                    error_eliminar_existencia=true
                }
        });

    }

    function orderTable(event) {
          if(cargando===false) {
          pageActual=0;
          orderField=event.detail.order;
          orderDir=event.detail.dir;
          loadData()
          }
    }
    
	  // import BotonCaja from './componentes/BotonCaja.svelte';
    // import { login, prefix, urlapi, viewsXpages } from './stores/store';
    // import Navbar from './components/Navbar.svelte';
    // import AnimationContainer from './components/AnimationContainer.svelte';
    // import Titlesection from "./components/Titlesection.svelte";
    // import { object2array, postData } from './scripts';
    // import { push } from 'svelte-spa-router';

    //   import SearchCombo from './components/SearchCombo.svelte';
    //   import Offcanvas from './components/Offcanvas.svelte';
    //   import Infopagination from './components/Infopagination.svelte';
    //   import Pagination from './components/Pagination.svelte';
    //   import Navbar from './components/Navbar.svelte';
  
    //   import { tabla_productos } from './stores/tablas.js';
  
    //   import TableResponsive from './components/Table/TableResponsive.svelte';
    //   import Searchsection from "./components/Searchsection.svelte";
    //   import Titlesection from "./components/Titlesection.svelte";
    //   import { moneda, object2array, postData } from './scripts';
    //   import { autentificado, prefix, urlapi, viewsXpages } from './stores/store';
    //   import { push } from 'svelte-spa-router';
    //   import AnimationContainer from './components/AnimationContainer.svelte';
  
    // let productos=[];
    // let ordenar=false;

    // function load()
    // {
    //     postData($urlapi, [{ 'cmd':'productos_list' }])
    //     .then(data => {
    //           productos=object2array(data[0].result.productos)
    //           //console.log(productos)
    //     });
    // }
    
    // let nuevo=function() { push('/productos/new') }

    // load();

    // let edit=function(index) {
    //   push('/productos/'+productos[index].id)
  	// }

    // function orderLeft(i)
    // {
    //     let obj1=productos[i];
    //     let obj2=productos[i-1];
    //     productos[i]=obj2;      
    //     productos[i-1]=obj1;
    // }

    // function orderRight(i)
    // {
    //     let obj1=productos[i];
    //     let obj2=productos[i+1];
    //     productos[i]=obj2;      
    //     productos[i+1]=obj1;
    // }
    // function saveOrder()
    // {
    //    let productosOrder=[];
    //    productos.forEach(element => { productosOrder.push({id:element.id}) });
    //    postData($urlapi, [{ 
    //         'cmd':'productos_orderSave', 
    //         'orden':productosOrder,
    //     }]).then(data => {
            
    //     });       
    // }
    // const options = {};
    
    let helper=false;

    let seleccionado=false;
    let selected= function (event) { 
        if(seleccionado==false || seleccionado!==event.detail.id) {
          seleccionado=event.detail.id
        } else {
          seleccionado=false
        }
    }

    let excel= function()
    {
        let get_search=`?search=`+encodeURIComponent(searchText)
        get_search+=`&sucursal=`+$sucursal
        //window.open($urlapp+'excel/productos_existencias.php'+get_search);
        document.location.href=$urlapp+'excel/productos_existencias.php'+get_search
    }

    function openCortediaUnidades()
    {
        fecha_cortediaUNIdesde=moment().format('YYYY-MM-DD');
        fecha_cortediaUNIhasta=moment().format('YYYY-MM-DD');
        observaciones_cortediaUNI='';
        
        Bsoffcanvas_cortediaUNI = new bootstrap.Offcanvas(offcanvas_cortediaUNI)
        Bsoffcanvas_cortediaUNI.show()
        campo_cortediaUNI.onlyFocusInNum(400)
    }

    function closeCortediaUNI()
    {
        Bsoffcanvas_cortediaUNI.hide()
    }

    function cortediaUNI()
    {
        let get_corte='';

        get_corte+=`?sucursal=`+encodeURIComponent($sucursal);

        let desde = moment(fecha_cortediaUNIdesde)
        let hasta = moment(fecha_cortediaUNIhasta)

        if(desde.isValid() && hasta.isValid()) 
        { 
            get_corte+=`&desde=`+encodeURIComponent(moment(fecha_cortediaUNIdesde,["DD-MM-YYYY","YYYY-MM-DD"]).format("YYYY-MM-DD"));
            get_corte+=`&hasta=`+encodeURIComponent(moment(fecha_cortediaUNIhasta,["DD-MM-YYYY","YYYY-MM-DD"]).format("YYYY-MM-DD"));
        } else {
            let actual = moment()
            get_corte+=`&desde=`+encodeURIComponent(moment(actual,["DD-MM-YYYY","YYYY-MM-DD"]).format("YYYY-MM-DD"));
            get_corte+=`&hasta=`+encodeURIComponent(moment(actual,["DD-MM-YYYY","YYYY-MM-DD"]).format("YYYY-MM-DD"));
        }
        if(observaciones_cortediaUNI.trim()!='') {get_corte+=`&observaciones=`+encodeURIComponent(observaciones_cortediaUNI)}
        window.open($urlapp+'print/corte_unidades_rango.php'+get_corte);
        closeCortediaUNI();
    }    
  </script>

{#if viewPage}
<Navbar />

<AnimationContainer>

    <Titlesection>
        <span slot="title"><i class="bi bi-box-seam me-1" />Productos</span>
        <span slot="toolbar">
            {#if $miPermiso.productos.insert===true}
                <button class='btn btn-primary' on:click={nuevo} on:mouseenter={()=>helper='Crear Registro'} on:mouseleave={()=>helper=false}><i class="bi bi-plus-circle"></i></button>
            {/if}
            
            {#if $miPermiso.productos.edit===true}
                <span on:mouseenter={()=>helper='Editar Registro'} on:mouseleave={()=>helper=false}>
                    <button disabled={!seleccionado} class='btn btn-success' on:click={()=>edit(seleccionado)}><i class="bi bi-pencil-square"></i></button>
                </span>
            {/if}

            {#if $miPermiso.productos.kardex===true}
                <span on:mouseenter={()=>helper='Ver Kardex'} on:mouseleave={()=>helper=false}>
                    <button disabled={!seleccionado} class='btn btn-warning' on:click={()=>kardex(seleccionado)}><i class="bi bi-file-earmark-spreadsheet"></i></button>
                </span>
            {/if}

            {#if $miPermiso.productos.export_existencias===true}
                <span on:mouseenter={()=>helper='Exportar a Excel'} on:mouseleave={()=>helper=false}>
                    <button class='btn btn-success' on:click={excel}><i class="bi bi-file-spreadsheet"></i></button>
                </span>
            {/if}

            {#if $miPermiso.productos.corteperiodo===true}
                <span on:mouseenter={()=>helper='Corte del día'} on:mouseleave={()=>helper=false}>
                    <button type="button" class="btn btn-success text-white dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                        <i class="bi bi-printer text-white me-1"></i><i class="bi bi-scissors text-white"></i>
                    </button>
                    <!-- svelte-ignore a11y-missing-attribute -->
                    <ul class="dropdown-menu">
                        <li><a class="dropdown-item" style='cursor:pointer;' on:click={openCortediaUnidades}><i class="bi bi-file-pdf me-1"></i>Corte de Unidades por rango</a></li>
                    </ul>                
                </span>
            {/if}


            {#if $miPermiso.productos.delete===true}
                <span on:mouseenter={()=>helper='Eliminar Registro'} on:mouseleave={()=>helper=false}>
                <Modal classButton='btn-danger' iconButton='bi-trash' functionSi={eliminar} title='ADVERTENCIA' disabled={!seleccionado}>
                    Esta seguro que desea <strong>Eliminar</strong> el registro?<br/>Se perderán todos los datos.
                </Modal>
                </span>
            {/if}

            {#if avanzado===false}
                <button class='btn btn-secondary' on:click={(e)=>{avanzado=!avanzado; eventSearch(e);}} on:mouseenter={()=>helper='buscador avanzado'} on:mouseleave={()=>helper=false}><i class="bi bi-funnel"></i></button>
            {:else}
                <button class='btn btn-success' on:click={(e)=>{avanzado=!avanzado; eventSearch(e);}} on:mouseenter={()=>helper='buscador avanzado'} on:mouseleave={()=>helper=false}><i class="bi bi-funnel"></i></button>
            {/if}

            <ButtonViewsXpages on:load={()=>{pageActual=0; loadData();}} on:mouseenter={()=>helper='Registros por página'} on:mouseleave={()=>helper=false}/>
            
            <BotonOrder uid={uid} on:mouseenter={()=>helper='Ordenar'} on:mouseleave={()=>helper=false} />
            
        </span>
    </Titlesection>

    <!-- OFFCANVAS CORTE UNIDADES -->
    <div class="offcanvas offcanvas-end" style='width:700px;' bind:this={offcanvas_cortediaUNI} tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
        <div class="offcanvas-header">
          <h5 id="offcanvasRightLabel">Corte de Unidades por rango</h5>
          <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div class="offcanvas-body pt-0">
            <div class="container-fluid border-top border-bottom pt-2 pb-2">
                <div class="row ">
                    <div class='col-12 mb-2'>
                        <!-- <Input label='Fecha de Corte' bind:value={fecha_cortediaUNI} tipo='date'/> -->
                        <Input label='Rango' bind:value={fecha_cortediaUNIdesde} bind:value2={fecha_cortediaUNIhasta} tipo='range' on:change={eventSearch} />
                    </div>
                    <div class='col-12 mb-2'>
                        <Input height=5 label='Observaciones' bind:value={observaciones_cortediaUNI} tipo='textarea' autofocus={true} bind:this={campo_cortediaUNI}/>
                    </div>
                    <div class='col-12'>
                        <button class='btn btn-success' on:click={cortediaUNI} on:mouseenter={()=>helper='Observaciones'} on:mouseleave={()=>helper=false}><i class="bi bi-save me-1"></i>Hacer Corte</button>
                        <button class='btn btn-danger' on:click={closeCortediaUNI} on:mouseenter={()=>helper='Salir del ingreso'} on:mouseleave={()=>helper=false}><i class="bi bi-arrow-return-left me-1"></i> Salir</button>
                    </div>                        
                </div>
            </div>
        </div>
    </div>

    {#if avanzado===true}
        <div class="container-fluid mt-1" in:fly={{y:-10,duration:500}}>
            <div class="row">
                 
                <div class='col-12 mb-2 mt-2'>
                    <Input label='Filtrar por ID, CÓDIGO, NOMBRE' bind:value={searchText} on:change={eventText} />
                </div>          
            </div>
        </div>
    {/if}

    <!-- DATA GRID -->
    <div class="container-fluid mt-2">
      <div class="row">
          <div class="col-12">

            {#if error_eliminar_existencia===true}
                <Alert status='danger' titulo='Error' valor='No se pudo eliminar el producto ya que aún hay existencias' on:close={()=>{ error_eliminar_existencia=false } } autoclose=10></Alert>
            {/if}
             
  
              <Datagrid bind:uid={uid} order={orderField} dir={orderDir} on:order={orderTable}>

                  
                  <svelte:fragment slot="header">
                      <DatagridTitle width='100px' order="id" title='ID'/>
                      <DatagridTitle width='100px' order="codigo" title='Código'/>
                      <DatagridTitle order="nombre" title='Descripción'/>
                      <DatagridTitle width='150px' order="precio" title='Precio' align='right'/>
                      <DatagridTitle width='130px' order="existencia" title='Existencia' align='right'/>
                  </svelte:fragment>
                  <svelte:fragment slot="body">
                  {#each datagrid as item}
                  <DatagridRow id={item.id} bind:seleccionado={seleccionado} on:select={selected}>
                          <DatagridCell title='Código'>{item.id}</DatagridCell>
                          <DatagridCell title='Existencia'>{item.codigo}</DatagridCell>
                          <DatagridCell title='Descripción' primary>{item.nombre}</DatagridCell>
                          <DatagridCell title='Precio' align='right'>{moneda(item.precio,'Q.')}</DatagridCell>
                          <DatagridCell title='Existencia' align='right'>{item.existencia}</DatagridCell>
                  </DatagridRow>
                  {/each}
                  
                  </svelte:fragment>
              </Datagrid>
  
          </div>
      </div>
    </div>


    <!-- PAGINACIÓN -->
    <div class="container mt-3">
      <div class="row">
          <div class="col-12 col-md-6 text-end text-md-start">
          <Infopagination data={dataPagination}/>
          </div>
          <div class="col-12 col-md-6">
          <Pagination selected={pageActual} data={dataPagination} on:page={eventPage}/>
          </div>
      </div>
    </div>

    <Helper bind:text={helper}></Helper>

    <!-- <Titlesection>
        <svelte:fragment slot="title"><i class="bi bi-box-seam me-1" />Productos</svelte:fragment>
        <svelte:fragment slot="toolbar">
          <button class="btn btn-primary btn-sm" on:click={nuevo}><i class="bi bi-plus-circle me-1"></i>Nuevo Producto</button>
          {#if ordenar===false}
            <button class="btn btn-warning btn-sm" on:click={()=>{ordenar=true;}}><i class="bi bi-sort-numeric-down me-1"></i>Ordenar</button>
          {:else}
            <button class="btn btn-success btn-sm" on:click={()=>{ordenar=false;saveOrder();}}><i class="bi bi-save me-1"></i>Guardar Orden</button>
          {/if}
          
        </svelte:fragment>
    </Titlesection>

    <div animate:flip={options}></div> -->
<!-- svelte-ignore a11y-missing-attribute -->
    <!--<div class="container mt-5">
      <div class="row">

          {#each productos as item,index}
          
            <div class="col-12 col-md-6 col-lg-2 mb-4">
              <BotonCaja on:click={()=>edit(index)} id={item.id} image={item.image} color={item.color} precio={item.precio}>{item.nombre}</BotonCaja>
              {#if ordenar===true}
                  <div class='mt-1'>
                    {#if index>0}
                      
                      <a class='btn btn-lg btn-outline-dark p-1 ps-2 pe-2' style='cursor:pointer' on:click={()=>orderLeft(index)}><i class="bi bi-arrow-left-circle"></i></a>
                    {/if}
                    
                    {#if index<(productos.length-1)}
                      <a class='btn btn-lg btn-outline-dark p-1 ps-2 pe-2 float-end' style='cursor:pointer' on:click={()=>orderRight(index)}><i class="bi bi-arrow-right-circle"></i></a>
                    {/if}
                  </div>
              {/if}
            </div>
          {:else}
              No existen productos
          {/each}          

      </div>
    </div> -->

</AnimationContainer>
{/if}